export enum DocumentCodeCategory {
  INSPECTION = 'Inspectie',
  SCENARIO = 'Scenario',
  REPORT_EMAIL = 'ReportEmail',
}
